'use client';

import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { callToAction } from '@/uiComposites/interactive/callToAction';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { position } from '@/uiPrimitives/layout/position';
import { stack } from '@/uiPrimitives/layout/stack';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { hiddenAccessibleUnlessFocused } from '@/uiPrimitives/utility/display.css';
import {
	pointerEventsAuto,
	pointerEventsNone,
} from '@/uiPrimitives/utility/pointerEvents.css';
import { addTestSelector } from '@dop/shared/helpers/testSelector';
import { contentID } from './A11YSkipLinks.config';
import { translateInline } from '@/globals/translate/translateInline';
import { useIsInertBecauseOfMenu } from '../pageHeader/mainMenu/MainMenu.client';
import { usePathname } from 'next/navigation';
import { searchPath } from '@/globals/config/localization.config';

export const A11YSkipLinks = () => {
	const inert = useIsInertBecauseOfMenu();

	const pathname = usePathname();
	const isSearchPage = pathname.startsWith(searchPath);

	return (
		<ul
			inert={inert}
			className={classes(
				position({
					position: 'absolute',
					insetBlockStart: '0',
					insetInline: '0',
				}),
				zIndex({ zIndex: 'skipLinks' }),
				stack({
					alignItems: 'center',
				}),
				box({
					paddingBlockStart: '1 | h3',
				}),
				pointerEventsNone,
			)}
		>
			<li className={classes(box({ inlineSize: 'fit-content' }))}>
				<DOPLink
					href={`#${contentID}`}
					data-link-type="skipLink"
					className={classes(
						pointerEventsAuto,
						callToAction({}),
						hiddenAccessibleUnlessFocused,
					)}
					{...addTestSelector('uiSkiplinkContent')}
				>
					{translateInline({
						en: 'Skip to main content',
						nl: 'Ga direct naar inhoud',
					})}
				</DOPLink>
			</li>
			{!isSearchPage && (
				<li className={classes(box({ inlineSize: 'fit-content' }))}>
					<DOPLink
						href={searchPath}
						data-link-type="skipLink"
						className={classes(
							pointerEventsAuto,
							callToAction({}),
							hiddenAccessibleUnlessFocused,
						)}
						{...addTestSelector('uiSkiplinkSearch')}
					>
						{translateInline({
							en: 'Go to the search page',
							nl: 'Ga naar de zoeken pagina',
						})}
					</DOPLink>
				</li>
			)}
		</ul>
	);
};
